import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Radio from 'components/Input/Radio';

const SquareRadio = ({ id, input, label, small }) => {
    const checked = input.value === id;

    const wrapperClasses = classnames({
        'radio-square': true,
        'radio-square--checked': checked,
        'radio-square--small': small,
    });

    return (
        <label htmlFor={id} className={wrapperClasses}>
            <Radio id={id} input={input} checked={checked} className="radio-square__radio" />
            {label}
        </label>
    );
};

SquareRadio.displayName = 'SquareRadio';

SquareRadio.propTypes = {
    id: PropTypes.string,
    input: PropTypes.shape({
        value: PropTypes.string,
    }).isRequired,
    label: PropTypes.string,
    small: PropTypes.bool,
};

SquareRadio.defaultProps = {
    id: '',
    label: '',
    small: false,
};

/**
 * SquareRadio Functional Component.
 */
export default SquareRadio;
